module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-898896.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
 ** module id = 913
 ** module chunks = 2
 **/